import React from 'react'
import isMobile from 'ismobilejs'
import {
  Container,
  Button,
  TextBody,
  ListContainer
} from '@pmi/pmi-iqos-ds-react'
import {
  htmlTranslation,
  goTo,
  Routes,
  analytics
} from '@pmi/pmi-iqos-shared-react'

const CartCheckoutGuestActions = ({
  translations,
  topButtons = false,
  compact
}) => {
  const handleLoginRedirect = () => {
    analytics.registrationEvent('Login on Cart')
    goTo(Routes.userLogin, false, false, [
      `callredirectUrl=${Routes.checkout}`,
      `skipredirectUrl=${Routes.cart}`
    ])
  }

  const handleRegistrationRedirect = () => {
    analytics.registrationEvent('Register on Cart')
    goTo(Routes.register, true, false, [
      `callredirectUrl=${Routes.checkout}`,
      `skipredirectUrl=${Routes.cart}`
    ])
  }

  return (
    <ListContainer columns={[topButtons ? 2 : 1, 2]} xBetween="8" yBetween="4">
      <Container
        display={Container.displays.flex}
        justifyContent={Container.justifyContentValues.end}
        alignItems={Container.alignItemsValues.center}
        flexDirection={Container.flexDirections.column}>
        {(!isMobile().any || topButtons) && (
          <TextBody
            size={TextBody.sizes.xs}
            {...htmlTranslation(translations, 'tk_goToLoginButtonLabel')}
          />
        )}
        <Button
          fullWidth
          variant={Button.variants.primary}
          text={translations.tk_goToLoginButton}
          onClickHandler={handleLoginRedirect}
          data-testing={
            compact
              ? 'Cart_GoToLoginSticky'
              : topButtons
              ? 'Cart_GoToLoginTop'
              : 'Cart_GoToLogin'
          }
        />
      </Container>
      <Container
        display={Container.displays.flex}
        justifyContent={Container.justifyContentValues.end}
        alignItems={Container.alignItemsValues.center}
        flexDirection={Container.flexDirections.column}>
        {(!isMobile().any || topButtons) && (
          <TextBody
            size={TextBody.sizes.xs}
            {...htmlTranslation(translations, 'tk_goToRegisterButtonLabel')}
          />
        )}
        <Button
          fullWidth
          variant={Button.variants.primary}
          text={translations.tk_goToRegisterButton}
          onClickHandler={handleRegistrationRedirect}
          data-testing={
            compact
              ? 'Cart_GoToRegisterSticky'
              : topButtons
              ? 'Cart_GoToRegisterTop'
              : 'Cart_GoToRegister'
          }
        />
      </Container>
    </ListContainer>
  )
}

export default CartCheckoutGuestActions
